import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap-5';

import querystring from 'querystring';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faSpinner } from '@fortawesome/pro-solid-svg-icons';

import { getCookieValue } from 'helpers/cookie_helpers';
import { identity, pickBy } from 'lodash';
import { Dropdown } from 'react-bootstrap-5';

// This is useful as a generic downloader component, so we've aliased it in download_button.js. TODO: refactor
// DownloadButton so it's generic, and this component can rely on the generic one.
export default class CsvDownloadButton extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    entityName: PropTypes.string,
    fileType: PropTypes.string,
    filters: PropTypes.object,
    hasButtonToRight: PropTypes.bool,
    href: PropTypes.string,
    menuIconColor: PropTypes.bool,
    menuIconSize: PropTypes.oneOf(['sm', 'md', 'lg']),
    messageOverride: PropTypes.string,
    type: PropTypes.oneOf(['Button', 'Icon', 'MenuItem']),
    onClick: PropTypes.func
  };

  static defaultProps = {
    fileType: 'CSV',
    hasButtonToRight: true,
    menuIconColor: true,
    menuIconSize: 'sm',
    type: 'Icon'
  };

  state = {
    interval: null,
    key: Math.random().toString(36).substring(7)
  }

  componentWillUnmount() {
    this.clearPreviousInterval();
  }

  clearPreviousInterval = () => {
    if (this.state.interval) {
      clearInterval(this.state.interval);
    }

    this.setState({ interval: null });
  }

  startDownload = () => {
    this.clearPreviousInterval();
    this.setState({ interval: setInterval(this.checkDownloadComplete, 250) });
  }

  checkDownloadComplete = () => {
    if (getCookieValue('download_key') === this.state.key) {
      this.clearPreviousInterval();

      const error = getCookieValue(`${this.state.key}_error`);
      if (error) {
        alert(error.replace(new RegExp('\\+', 'g'), ' '));
      }
    }
  }

  path() {
    const joinCharacter = this.props.href.includes('?') ? '&' : '?';
    const filterString = this.buildFilterParams();

    if (filterString) {
      return `${this.props.href}${joinCharacter}key=${this.state.key}&${filterString}`;
    } else {
      return `${this.props.href}${joinCharacter}key=${this.state.key}`;
    }
  }

  buildFilterParams() {
    const filters = pickBy(this.props.filters, identity);

    return querystring.stringify(filters);
  }

  message = () => this.props.messageOverride || `Download ${this.props.entityName || ''} as ${this.props.fileType}`;

  render() {
    switch (this.props.type) {
    case 'Button':
      return this.renderButton();
    case 'Icon':
      return this.renderIcon();
    case 'MenuItem':
      return this.renderMenuItem();
    }
  }

  renderButton() {
    if (this.state.interval) {
      return (
        <button className="btn btn-secondary">
          <FontAwesomeIcon icon={faSpinner} name="spinner" spin />
        </button>
      );
    }

    return (
      <a
        className={`btn btn-secondary ${this.props.hasButtonToRight ? 'me-2' : ''}`}
        download
        href={this.path()}
        name="download"
        onClick={this.startDownload}
      >
        <span className="hidden-xs">{this.message()}</span>
        <span className="visible-xs">
          <FontAwesomeIcon icon={faDownload} />
        </span>
      </a>
    );
  }

  renderIcon() {
    if (this.state.interval) {
      return (
        <FontAwesomeIcon className="right-buffer-md text-muted" icon={faSpinner} name="spinner" size="2x" spin />
      );
    } else {
      const tooltip = <Tooltip id="csv-tooltip">{this.message()}</Tooltip>;
      return (
        <OverlayTrigger overlay={tooltip} placement="left">
          {this.props.onClick ? (
            <div className="clickable" onClick={this.props.onClick}>
              <FontAwesomeIcon className="right-buffer-md text-muted" icon={faDownload} size="2x" />
            </div>
          ) : (
            <a download href={this.path()} name="download" onClick={this.startDownload}>
              <FontAwesomeIcon className="right-buffer-md text-muted" icon={faDownload} size="2x" />
            </a>
          )}
        </OverlayTrigger>
      );
    }
  }

  renderMenuItem() {
    const { interval } = this.state;
    const disabled = !!interval || this.props.disabled;
    const iconSizeProps = this.props.menuIconSize === 'md' ? {} : { size: this.props.menuIconSize };

    return (
      <Dropdown.Item
        disabled={disabled}
        download
        eventKey="download_csv"
        href={this.path()}
        name="download"
        onSelect={() => {
          this.startDownload();
          if (this.props.onClick) this.props.onClick();
        }}
      >
        <FontAwesomeIcon
          className={`mr-2 ${this.props.menuIconColor ? 'bo-menu-icon' : ''} ${disabled ? 'disabled' : ''}`}
          fixedWidth
          icon={faDownload}
          {...iconSizeProps}
        /> {interval ? 'Downloading...' : this.message()}
      </Dropdown.Item>
    );
  }
}
